import { trackDemoRequest } from '@/lib/analytics';
import { cn } from '@/lib/utils';
import { useNavigate } from 'react-router-dom';

interface AnimatedButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  trackingSource?: string;
  className?: string;
}

const DEMO_EMAIL = 'contact@somatiq.ai';
const DEMO_SUBJECT = 'Demo Request - Somatiq Platform';
const DEMO_BODY = 'Hi Somatiq team,\n\nI would like to schedule a demo of your platform.\n\nPlease let me know your availability.\n\nThank you!';

export function AnimatedButton({ children, onClick, href, trackingSource = 'unknown', className }: AnimatedButtonProps) {
  const navigate = useNavigate();
  
  const handleClick = () => {
    // Track the conversion event
    trackDemoRequest(trackingSource);

    if (onClick) {
      onClick();
    } else if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else {
      // Default action: navigate to book-a-demo page
      navigate('/book-a-demo');
    }
  };

  return (
    <div className="relative">
      <div className="relative rounded-lg">
        <div className="absolute inset-0 bg-[#006AE5]/70 z-10 blur-2xl w-[70%] mx-auto" />
        <div className={cn("relative z-20 p-3",className)}>
          <button
            onClick={handleClick}
            className={cn("px-6 py-3 sm:px-9 sm:py-4 text-sm sm:text-[15px] bg-[#056EE7]/20 border border-[#056EE7]/40 font-semibold tracking-wider uppercase text-foreground rounded-md cursor-pointer transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 overflow-hidden")}
          >
            {children}
          </button>
        </div>
      </div>
    </div>
  );
}